// stdlib es6 polyfills
// make sure closure compiler knows about these functions so that it can polyfill them

[...'abc'].flat();